import { memo } from 'react'
import { SxProps } from '@mui/material'
import { useLayoutHeight } from '@/utils'
import { Text } from '@/components/Data'
import { Box, PageLayout } from '@/components/Layout'
import { errorPageStyles as styles } from './ErrorPage.style'
import { ErrorPageProps } from './ErrorPage.types'

function ErrorPage({
  title,
  description,
  sx,
  contentWrapperProps = {},
  titleTextProps = {},
  descriptionTextProps = {},
  children,
  ...rest
}: ErrorPageProps) {
  const { layoutOccupiedHeight } = useLayoutHeight()

  // props extraction
  const { sx: contentWrapperSx, ...otherContentWrapperProps } = contentWrapperProps
  const { sx: titleTextSx, ...otherTitleTextProps } = titleTextProps
  const { sx: descriptionTextSx, ...otherDescriptionTextProps } = descriptionTextProps
  return (
    <PageLayout>
      <Box
        sx={
          [
            styles.container,
            { height: `calc(100vh - ${layoutOccupiedHeight}px)`, pb: `${layoutOccupiedHeight}px` },
            sx,
          ] as SxProps
        }
        {...rest}>
        <Box
          sx={[styles.contentWrapper, contentWrapperSx] as SxProps}
          {...otherContentWrapperProps}>
          <Text
            component={'h1'}
            sx={[styles.title, titleTextSx] as SxProps}
            {...otherTitleTextProps}>
            {title}
          </Text>
          <Text
            component={'h2'}
            sx={[styles.text, descriptionTextSx] as SxProps}
            {...otherDescriptionTextProps}>
            {description}
          </Text>

          {children}
        </Box>
      </Box>
    </PageLayout>
  )
}

export default memo(ErrorPage)
